import { ReportData } from '../types/reportTypes';

// December 2025 Sales Data - Standard Report (31 jobs from CSV)
const jobData = [
  {
    jobInfo: "E-764: James Peffall",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2372.00,
    grossMarginPct: 0.5868,
    grossProfit: 1391.89,
    commissionPercentage: 7.00,
    salesCommission: 166.04,
    salesManagerFee: 23.72,
    companyOH: 367.66,
    netProfit: 0
  },
  {
    jobInfo: "E-771: SEDNAOUI MAKAR",
    leadSource: "Porch",
    trade: "Roofing",
    contractTotal: 7000.00,
    grossMarginPct: 0.4176,
    grossProfit: 2923.20,
    commissionPercentage: 4.00,
    salesCommission: 280.00,
    salesManagerFee: 70.00,
    companyOH: 1085.00,
    netProfit: 0
  },
  {
    jobInfo: "E-755: Andre & Nancy Williamson",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 4241.10,
    grossMarginPct: 0.6999,
    grossProfit: 2968.35,
    commissionPercentage: 10.00,
    salesCommission: 424.11,
    salesManagerFee: 42.41,
    companyOH: 657.37,
    netProfit: 0
  },
  {
    jobInfo: "E-750: Chris & Sherry Lynne Bowman",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 3300.00,
    grossMarginPct: 0.4245,
    grossProfit: 1400.85,
    commissionPercentage: 4.00,
    salesCommission: 132.00,
    salesManagerFee: 33.00,
    companyOH: 511.50,
    netProfit: 0
  },
  {
    jobInfo: "E-752: Rene & MELANIE Moreno",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 22221.00,
    grossMarginPct: 0.4012,
    grossProfit: 8915.07,
    commissionPercentage: 4.00,
    salesCommission: 888.84,
    salesManagerFee: 222.21,
    companyOH: 3444.26,
    netProfit: 0
  },
  {
    jobInfo: "E-743: Christine Andrews",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 5202.80,
    grossMarginPct: 0.4182,
    grossProfit: 2175.81,
    commissionPercentage: 4.00,
    salesCommission: 208.11,
    salesManagerFee: 52.03,
    companyOH: 806.43,
    netProfit: 0
  },
  {
    jobInfo: "Micheale & Priscilla Farhood",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 6672.00,
    grossMarginPct: 0.4000,
    grossProfit: 2668.80,
    commissionPercentage: 4.00,
    salesCommission: 266.88,
    salesManagerFee: 66.72,
    companyOH: 1034.16,
    netProfit: 0
  },
  {
    jobInfo: "Aaron Buckler",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 3421.00,
    grossMarginPct: 0.6171,
    grossProfit: 2111.10,
    commissionPercentage: 10.00,
    salesCommission: 342.10,
    salesManagerFee: 34.21,
    companyOH: 530.26,
    netProfit: 0
  },
  {
    jobInfo: "Donny Knepper & Vlatka Tomazic Knepper/Tomazic",
    leadSource: "Self Generated Lead (By Rep)",
    trade: "Entry Doors",
    contractTotal: 5892.00,
    grossMarginPct: 0.4000,
    grossProfit: 2356.80,
    commissionPercentage: 4.00,
    salesCommission: 235.68,
    salesManagerFee: 58.92,
    companyOH: 913.26,
    netProfit: 0
  },
  {
    jobInfo: "Darryl Smith",
    leadSource: "eLocal",
    trade: "Roofing",
    contractTotal: 7326.00,
    grossMarginPct: 0.4424,
    grossProfit: 3241.02,
    commissionPercentage: 4.00,
    salesCommission: 293.04,
    salesManagerFee: 73.26,
    companyOH: 1135.53,
    netProfit: 0
  },
  {
    jobInfo: "Betty & Robert Meck",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 16821.00,
    grossMarginPct: 0.4000,
    grossProfit: 6728.40,
    commissionPercentage: 4.00,
    salesCommission: 672.84,
    salesManagerFee: 168.21,
    companyOH: 2607.26,
    netProfit: 0
  },
  {
    jobInfo: "David & Devon Gessert",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 6122.00,
    grossMarginPct: 0.4062,
    grossProfit: 2486.76,
    commissionPercentage: 4.00,
    salesCommission: 244.88,
    salesManagerFee: 61.22,
    companyOH: 948.91,
    netProfit: 0
  },
  {
    jobInfo: "Barbara Hunt",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 7772.00,
    grossMarginPct: 0.4000,
    grossProfit: 3108.80,
    commissionPercentage: 4.00,
    salesCommission: 310.88,
    salesManagerFee: 77.72,
    companyOH: 1204.66,
    netProfit: 0
  },
  {
    jobInfo: "Karena Sylvester",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 10793.00,
    grossMarginPct: 0.4000,
    grossProfit: 4317.20,
    commissionPercentage: 4.00,
    salesCommission: 431.72,
    salesManagerFee: 107.93,
    companyOH: 1672.92,
    netProfit: 0
  },
  {
    jobInfo: "E-760: Patty Sheetz",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2619.00,
    grossMarginPct: 0.6220,
    grossProfit: 1629.02,
    commissionPercentage: 10.00,
    salesCommission: 261.90,
    salesManagerFee: 26.19,
    companyOH: 405.95,
    netProfit: 0
  },
  {
    jobInfo: "E-763: Noah Phillips",
    leadSource: "Self Generated Lead (By Rep)",
    trade: "Roofing",
    contractTotal: 7400.00,
    grossMarginPct: 0.4838,
    grossProfit: 3580.12,
    commissionPercentage: 4.00,
    salesCommission: 296.00,
    salesManagerFee: 74.00,
    companyOH: 1147.00,
    netProfit: 0
  },
  {
    jobInfo: "E-744: Kevin & AMY Woest",
    leadSource: "Referral - From past customer",
    trade: "Roofing",
    contractTotal: 25372.00,
    grossMarginPct: 0.4929,
    grossProfit: 12505.86,
    commissionPercentage: 4.00,
    salesCommission: 1014.88,
    salesManagerFee: 253.72,
    companyOH: 3932.66,
    netProfit: 0
  },
  {
    jobInfo: "E-742: Paul & Chinfang Smith",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 20572.00,
    grossMarginPct: 0.5028,
    grossProfit: 10343.60,
    commissionPercentage: 7.00,
    salesCommission: 1440.04,
    salesManagerFee: 205.72,
    companyOH: 3188.66,
    netProfit: 0
  },
  {
    jobInfo: "E-751: Tom & Corrine Eckley",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 13372.00,
    grossMarginPct: 0.4137,
    grossProfit: 5532.00,
    commissionPercentage: 4.00,
    salesCommission: 534.88,
    salesManagerFee: 133.72,
    companyOH: 2072.66,
    netProfit: 0
  },
  {
    jobInfo: "E-748: Steven & Shannon Menefee",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 17221.00,
    grossMarginPct: 0.4439,
    grossProfit: 7644.40,
    commissionPercentage: 4.00,
    salesCommission: 688.84,
    salesManagerFee: 172.21,
    companyOH: 2669.26,
    netProfit: 0
  },
  {
    jobInfo: "E-756: Michael & Cinthya Cole",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 19972.00,
    grossMarginPct: 0.4012,
    grossProfit: 8012.77,
    commissionPercentage: 4.00,
    salesCommission: 798.88,
    salesManagerFee: 199.72,
    companyOH: 3095.66,
    netProfit: 0
  },
  {
    jobInfo: "Joanne Fleming",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 44590.00,
    grossMarginPct: 0.4000,
    grossProfit: 17836.00,
    commissionPercentage: 4.00,
    salesCommission: 1783.60,
    salesManagerFee: 445.90,
    companyOH: 6911.45,
    netProfit: 0
  },
  {
    jobInfo: "Tom & Maria Wigfield",
    leadSource: "Referral - From past customer",
    trade: "Siding",
    contractTotal: 8472.00,
    grossMarginPct: 0.4874,
    grossProfit: 4129.25,
    commissionPercentage: 4.00,
    salesCommission: 338.88,
    salesManagerFee: 84.72,
    companyOH: 1313.16,
    netProfit: 0
  },
  {
    jobInfo: "Anne & Richard Zaworski",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 3300.00,
    grossMarginPct: 0.4000,
    grossProfit: 1320.00,
    commissionPercentage: 4.00,
    salesCommission: 132.00,
    salesManagerFee: 33.00,
    companyOH: 511.50,
    netProfit: 0
  },
  {
    jobInfo: "Glen Woodger",
    leadSource: "Self Generated Lead (By Rep)",
    trade: "Windows & Doors",
    contractTotal: 5972.00,
    grossMarginPct: 0.4000,
    grossProfit: 2388.80,
    commissionPercentage: 4.00,
    salesCommission: 238.88,
    salesManagerFee: 59.72,
    companyOH: 925.66,
    netProfit: 0
  },
  {
    jobInfo: "E-770: Damon Brown",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 3000.00,
    grossMarginPct: 0.5867,
    grossProfit: 1760.10,
    commissionPercentage: 7.00,
    salesCommission: 210.00,
    salesManagerFee: 30.00,
    companyOH: 465.00,
    netProfit: 0
  },
  {
    jobInfo: "E-769: Jason & Lisa Doll",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 4772.00,
    grossMarginPct: 0.3372,
    grossProfit: 1609.12,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 47.72,
    companyOH: 739.66,
    netProfit: 0
  },
  {
    jobInfo: "E-759: David Robertson",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 4061.00,
    grossMarginPct: 0.6947,
    grossProfit: 2821.18,
    commissionPercentage: 10.00,
    salesCommission: 406.10,
    salesManagerFee: 40.61,
    companyOH: 629.46,
    netProfit: 0
  },
  {
    jobInfo: "E-766: John Offre",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 2723.77,
    grossMarginPct: 0.4530,
    grossProfit: 1233.87,
    commissionPercentage: 4.00,
    salesCommission: 108.95,
    salesManagerFee: 27.24,
    companyOH: 422.18,
    netProfit: 0
  },
  {
    jobInfo: "E-768: Jonathon & Samantha Kalobqcar",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 5870.00,
    grossMarginPct: 0.5431,
    grossProfit: 3188.00,
    commissionPercentage: 7.00,
    salesCommission: 410.90,
    salesManagerFee: 58.70,
    companyOH: 909.85,
    netProfit: 0
  },
  {
    jobInfo: "E-745: Donna Brown",
    leadSource: "Referral - Word of mouth",
    trade: "Roofing",
    contractTotal: 15146.90,
    grossMarginPct: 0.4838,
    grossProfit: 7328.07,
    commissionPercentage: 4.00,
    salesCommission: 605.88,
    salesManagerFee: 151.47,
    companyOH: 2347.77,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  // For Standard Reports: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from December 2025 CSV
const adSpendData = [
  { source: "Networx", spend: 1000.00 },
  { source: "Thumbtack", spend: 8045.00 },
  { source: "Yelp", spend: 12926.95 },
  { source: "Porch", spend: 910.00 },
  { source: "Web to Lead Form", spend: 2365.00 },
  { source: "Angi", spend: 2488.00 },
  { source: "Homebuddy", spend: 2970.00 },
  { source: "RoofHero", spend: 4100.00 },
  { source: "Buyerlink", spend: 0.00 },
  { source: "Lead2performance", spend: 0.00 },
  { source: "Contractors Appointments", spend: 0.00 },
  { source: "Google Organic Search", spend: 7000.00 },
  { source: "Google Paid Search", spend: 7649.00 },
  { source: "Facebook / Meta Ads", spend: 2213.00 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Other", spend: 0.00 },
  { source: "Blank", spend: 0.00 },
  { source: "Truck", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Suburban MD Spring Home Show", spend: 0.00 },
  { source: "Yard Sign", spend: 0.00 },
  { source: "ROI Sales Portal", spend: 0.00 },
  { source: "Modernize", spend: 0.00 },
  { source: "33 Mile Radius / Everconnect", spend: 2098.00 },
  { source: "eLocal", spend: 2000.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

// Create the final report data object
export const decemberData: ReportData = {
  kpis: {
    // Total ad spend
    adSpend: totalAdSpend,

    // Sum of all contract totals
    totalSales: totalContractValue,

    // Sum of all gross profits
    grossProfit: totalGrossProfit,

    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,

    // Sum of all manager fees
    managerFees: totalManagerFees,

    // Company overhead
    companyOH: totalCompanyOH,

    // Net profit (standard calculation) minus ad spend
    netProfit: totalNetProfit - totalAdSpend,

    // Net profit as percentage of total sales
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,

    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  // Ad spend by source with all sources
  adSpendBySource: adSpendData,

  // Sales by lead source - aggregated above
  salesBySource: salesBySource,

  // Sales by trade - aggregated above
  salesByTrade: salesByTrade,

  // Individual job data
  jobData: jobData,

  // Report period information
  period: {
    month: 12, // December
    year: 2025
  }
};
